import { useFormik } from "formik";
import React, { useContext, useState } from "react";
import { deleteAcctPassword } from "../../components/Validation";
import { AppContext } from "../../appContext";
import toast from "react-hot-toast";
import ConfirmPopup from "../../components/confirmPopup/ConfirmPopup";
import SimpleButton from "../../components/common/buttons/SimpleButton/SimpleButton";
import { EditProfileLoader } from "../../components/common/loader";
import { InputErrorMessage } from "../../components/errorMessages";
import { IoEye, IoEyeOff } from "react-icons/io5";
import MandatoryLabel from "../../components/common/label";
import { DeleteAccountAPI } from "../../apis";

export default function DeleteAccountSection({ }) {
    const [passwordType, setPasswordType] = useState("password");
    const [loader, setLoader] = useState(false);
    const [declinePopup, setDeclinePopup] = useState(false);
    const { logout } = useContext(AppContext);
    function handelConfirmPopUp() {
        setDeclinePopup(!declinePopup);
    }
    const formik = useFormik({
        initialValues: {
            password: "",
        },
        validationSchema: deleteAcctPassword,
        onSubmit: async (values) => {
            console.log(values);
            try {
                setLoader(true);
                const res = await DeleteAccountAPI({
                    userid: localStorage.getItem("userId"),
                    password: password,
                });
                if (res.status === 200) {
                    toast.success(res.data.message);
                    setDeclinePopup(false);
                    logout();
                }
            } catch (error) {
                console.log(error);
                setLoader(false);
                const message = error.response.data.error || error.response.statusText;
                toast.error(message, { id: "error" });
                setDeclinePopup(false);
            }
        },
    });
    const { password } = formik.values;
    const handleChange = (e) => {
        e.preventDefault();
        formik.handleChange(e);
    };
    function handelPasswordType() {
        if (passwordType == "text") {
            setPasswordType("password");
        } else if (passwordType == "password") {
            setPasswordType("text");
        }
    }
    return (
        <section className="pt-[14%] pb-10 max-w-md md:max-w-[80vw] lg:max-w-[40vw] md:pt-[6%] md:ml-[auto] md:mr-[auto] lg:ml-1  px-6 lg:bg-transparent bg-white lg:pt-[0px] lg:pb-[0px] lg:my-7 lg:px-2 marginx_auto custom_x_margin custom_pt_md">
            <div className="flex justify-center items-center flex ml-auto mr-auto flex-col gap-1">
                <img
                    src={require("../../images/Account deleting.png")}
                    className="object-contain mb-2"
                />
                <div className="text-base font-medium lg:text-lg lg:font-medium text-center !mb-2">
                    Deleting your account will make it immediately inaccessible
                </div>
                <p className="text-navLink text-sm text-center">
                    All your data and settings will be deleted immediately.
                </p>
            </div>


            <form className="mt-8 space-y-4 max-w-md md:max-w-[80vw] lg:max-w-[40vw] md:ml-auto md:mr-auto">
                <h2 className=" !font-medium baseText">
                    Please verify your account before deleting.
                </h2>
                <div className="relative">
                    <MandatoryLabel title="Enter your password" />
                    <div className="relative">
                        <input
                            type={passwordType}
                            name="password"
                            className={
                                Boolean(formik.touched.password) &&
                                    Boolean(formik.errors.password)
                                    ? "form-control border-danger transparent-input-border"
                                    : "form-control transparent-input-border"
                            }
                            id="password"
                            placeholder="Password "
                            value={formik.values.password}
                            onChange={handleChange}
                        />
                        <div
                            className="absolute top-1/2 -translate-y-1/2 right-4 p-2 cursor-pointer"
                            onClick={handelPasswordType}
                        >
                            {passwordType == "password" ? (
                                <IoEyeOff />
                            ) : passwordType == "text" ? (
                                <IoEye />
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                    <InputErrorMessage
                        error={formik.touched.password && formik.errors.password}
                    />
                </div>

                <SimpleButton
                    customClass={"bg-accent text-white rounded-md w-full"}
                    buttonType={"primary"}
                    title={loader ? <EditProfileLoader /> : "Delete Account"}
                    onClickEvent={(e) => {
                        e.preventDefault();
                        if (formik.isValid && password) {
                            handelConfirmPopUp();
                        } else {
                            formik.handleSubmit();
                        }
                    }}
                    buttonFunction={"openModal"}
                />
                
            </form>
            {declinePopup && (
                    <ConfirmPopup
                        message={"Are you sure you want to delete your account?"}
                        popupStatus={declinePopup}
                        handelConfirmPopUp={() => handelConfirmPopUp()}
                        onclickFunction={formik.handleSubmit}
                        forDeleteAccount={true}
                    />
                )}
        </section>
    )
}